<template>
  <v-card id="consignee" class="mt-4">
    <v-card-title class="primary h5 text-white">{{
      $t(item.title)
    }}</v-card-title>
    <v-card-text class="pt-2">
      <template v-if="item.data.length > 0">
        <div
          v-for="(element, index) in item.data"
          :key="index"
          class="d-flex justify-space-between align-center mb-3"
        >
          <span class="font-weight-bolder font-size-lg pe-3"
            >{{ $t(element.title) }}:
          </span>
          <div>
            <a
              target="_blank"
              class="btn btn-sm btn-light-info font-size-sm"
              :href="element.file"
              >{{ $t("click_to_open_file") }}</a
            >
          </div>
        </div>
      </template>
      <span v-else class="font-weight-bolder">{{
        $t("there_are_no_uploaded_documents")
      }}</span>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "PopUpDocs",
  props: ["item"],
};
</script>

<style></style>
